import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 0.5rem;
  width: 100%;
  padding: 0 0.125rem;

  @media (max-width: 1400px) {
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 0.375rem;
  }

  @media (max-width: 1200px) {
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    gap: 0.25rem;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;
    padding: 0 0.125rem;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 0.5rem;
    padding: 0 0.125rem;
  }
`;